import {Validators} from '@angular/forms';

import {TaxNumberValidator} from '@spa/validators';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, CountryAutocompleteControl} from '../../../app/shared/classes';

export const TaxDetailsFormArraySelector = 'taxDetails';
export const TaxDetailIdSelector = 'id';
export const TaxDetailCountryIdSelector = 'countryId';
export const TaxDetailTaxNumberSelector = 'taxNumber';

export const TaxDetailTaxNumberMaxLength = 30;

export const TaxDetailControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: TaxDetailIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true,
            hidden: true
        }),
        new CountryAutocompleteControl({
            name: TaxDetailCountryIdSelector,
            value: null,
            placeholder: 'Tax country',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.CountryAutocomplete,
            options: [],
            countries: [],
            floatingLabelNever: true
        }),
        new BaseControl({
            name: TaxDetailTaxNumberSelector,
            value: '',
            placeholder: 'Tax number',
            validators: [Validators.maxLength(TaxDetailTaxNumberMaxLength), TaxNumberValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        })
    ];
};
